import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./AppInsights"; // enable Azure Insights
import "react-tooltip/dist/react-tooltip.css";
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes,
} from "../node_modules/react-router-dom/dist/index";
import Acceuil from "./components/accueil/Accueil";
import Contact from "./components/contact/Contact";
import Experiences from "./components/experiences/Experiences";
import Competences from "./components/competences/Competences";
import PageInexistante from "./PageInexistante";
import MentionsLegales from "./components/mentions-legales/MentionsLegales";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App/>}>
                    <Route index element={<Navigate to="accueil"/>}/>
                    <Route path="accueil" element={<Acceuil/>}/>
                    <Route path="experiences" element={<Experiences/>}/>
                    <Route path="competences" element={<Competences/>}/>
                    <Route path="contact" element={<Contact/>}/>
                    <Route path="mentions-legales" element={<MentionsLegales/>}/>
                    <Route path="*" element={<PageInexistante/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
